import React, { FC, ReactNode, useRef } from 'react';

interface Props {
  isOpen: boolean;
  className?: string;
  detailsClassName?: string;
  duration?: number;
  children?: ReactNode;
}

const defaultDuration = 300;

const defaultStyle = (duration: number) => ({
  transition: `height ${duration}ms ease-in-out`,
  overflow: 'hidden',
});

const heightConst0 = () => ({ height: 0 });
const height = (value: number) => ({ height: value });

const transitionStyles = {
  entered: height,
  exited: heightConst0,
};

export const ExpandableContent: FC<Props> = ({
  className,
  detailsClassName,
  duration = defaultDuration,
  children,
  isOpen,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);

  const getContentHeight = () =>
    contentRef.current ? contentRef.current.getBoundingClientRect().height : 0;

  return (
    <div className={className}>
      <div
        style={{
          ...defaultStyle(duration),
          ...transitionStyles[isOpen ? 'entered' : 'exited'](
            getContentHeight()
          ),
        }}
      >
        <div className={detailsClassName} ref={contentRef}>
          {children}
        </div>
      </div>
    </div>
  );
};
